<template>
  <div>
    <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span data-cy="addProduct-title" class="headline">
            Descargar reporte de depósitos
          </span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12">
                <div>
                  Selecciona un rango de fechas para exportar tu reporte de pagos en formato CSV.
                </div>
              </v-col>
              <v-col cols="12">
                <v-date-picker
                  v-model="month"
                  first-day-of-week="1"
                  type="month"
                  color="primary"
                  :allowed-dates="allowedDates"
                  no-title
                />
              </v-col>
              <v-col cols="12">
                <div>
                  Usa esta opción para que el reporte esté calculado por restaurante.
                </div>
                <div>
                  <v-checkbox v-model="grouped" label="Agrupar por restaurante"/>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            depressed
            @click="close">
            Cerrar
          </v-btn>
          <v-btn
            data-cy="addProduct-success"
            color="primary"
            class="mr-4"
            rounded
            small
            depressed
            :disabled="!this.dates.length === 2"
            :href="exportRoute"
            target="_blank">
            Descargar CSV
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isOpen: false,
      overlay: false,
      deposits: false,
      month: new Date().toISOString(),
      grouped: false,
      searchProduct: '',
      products: []
    }
  },
  computed: {
    provider () {
      return this.$store.state.currentProvider.data._id
    },
    exportRoute () {
      const dates = [...this.dates]
      dates.sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      let url = process.env.VUE_APP_API_URL
      url += `/v1/deposits/download?access_token=${this.$store.state.login.token}`
      url += `&user_provider=true`
      url += `&provider=${this.provider}`
      url += `&updatedAt>=${dates[0] || ''}&updatedAt<=${dates[1] || ''}`
      url += this.grouped ? `&grouped=true` : ''
      url += this.deposits ? '&deposits=true' : ''
      return url
    },
    dates () {
      const dates = []
      if (this.$moment(this.month).isValid()) {
        const start = this.$moment(this.month).startOf('month').format('YYYY-MM-DD')
        const end = this.$moment(this.month).endOf('month').format('YYYY-MM-DD')
        dates.push(start, end)
      }
      return dates
    }
  },
  methods: {
    open (options = { deposits: false }) {
      this.isOpen = true
      this.deposits = options.deposits
    },
    close () {
      this.isOpen = false
      this.deposits = false
    },
    allowedDates (val) {
      return this.$moment(val).isSameOrBefore(new Date())
    }
  }
}
</script>
